<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermission" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermission" [position]="'inline'" [lang]="currentLang">
      <span class="icon">
          <i class="fi fi-ss-search-alt"></i>
          {{"CustomerLabelMaintenance.Header" | translate}}
      </span>
  </h1>
  <p-card>
    <p-accordion>
        <p-accordionTab
                header="{{ 'Common.Form.Header' | translate }}"
                [selected]="true">
            <form [formGroup]="searchForm">
                <div class="col-12">
                  <div class="p-fluid formgrid grid ">
                    <div class="field col-3">
                      <label><span class="requiredStar">*</span>{{ 'CustomerLabelMaintenance.SearchForm.externOrderKey' | translate }}</label>
                      <input
                        pInputText
                        type="text"
                        formControlName="externOrderKey"
                        placeholder="e.g. 24339717-68333574"
                      />
                      <div *ngIf="searchForm.controls['externOrderKey'].invalid && (searchForm.controls['externOrderKey'].dirty || searchForm.controls['externOrderKey'].touched)">
                        <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
                      </div>
                    </div>
                    <div class="field col-12">
                      <small><strong class="p-invalid">
                        {{ 'CustomerLabelMaintenance.Message.NotificationOfQuery' | translate }}
                      </strong></small>
                    </div>
                  </div>
                </div>
                <div class="field col-12">
                  <div>
                    <button
                              pButton
                              pRipple
                              [disabled]="searchForm.invalid"
                              label="{{ 'Common.Button.Search' | translate }}"
                              (click)="searchBtnClick($event)"
                              >
                    </button>
                    <button
                              pButton
                              pRipple
                              label="{{ 'Common.Button.Reset' | translate }}"
                              (click)="resetBtnClick($event)"
                              class="p-button-secondary ml-2"
                              >
                    </button>
                  </div>
                </div>
            </form>
        </p-accordionTab>
    </p-accordion>


    <div class="mt-2">
      <div class="inline-block my-1">
            <button pButton pRipple
              (click)="sendMail($event)"
              [disabled]="!customerLabelHeaderRowData?.externOrderKey"
              class="p-button-success ml-4"
              label="{{ 'CustomerLabelMaintenance.Button.sendMail' | translate}}">
            </button>
      </div>
      <laas-data-table
        #customerLabelHeaderTable
        [tableKey]="headerPreferenceKey"
        [defaultColumns]="customerLabelHeaderColumns"
        [loading]="isLoadingHeader"
        [value]="customerLabelHeaderRowData ? [customerLabelHeaderRowData] : []"
        [lazy]="true"
        [paginator]="false"
        [editPermission]="editPermissionCode"
        [inputValid]="dataInputValid"
        [isShowCreateRowFunction]="false"
        (savedData)="saveCustomerLabelHeader($event)"
        [dataKey]="'seqNo'"
        >
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container *ngTemplateOutlet="defaultTemplate; context: { $implicit: rowData, col: col }">
             </ng-container>
          </td>
        </ng-template>
        <!--共用顯示模板-->
        <ng-template #displayCell let-rowData let-col="col">
          {{ rowData[col.field] | replaceNullWith : "-" }}
        </ng-template>
        <!--Output-->
        <ng-template #defaultTemplate pTemplate="bodyOutputTemplate" let-rowData let-col="col">
          <ng-container *ngTemplateOutlet="displayCell; context: { $implicit: rowData, col: col }"></ng-container>
        </ng-template>
        <!--Input-->
        <ng-template pTemplate="bodyInputTemplate" let-rowData let-col="col">
          <ng-container *ngIf="isHeaderColumnEditable(col.field); else elseTemplate">
                  <ng-container [ngSwitch]="col.field">
                    <ng-container *ngSwitchCase="'labelKey'">
                      <input
                        pInputText
                        type="number"
                        min="1"
                        class="p-inputtext p-component p-element p-filled"
                        [(ngModel)]="rowData[col.field]"
                      />
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <input
                        pInputText
                        type="text"
                        class="p-inputtext p-component p-element p-filled"
                        [(ngModel)]="rowData[col.field]"
                      />
                    </ng-container>
                  </ng-container>
          </ng-container>
          <ng-template #elseTemplate>
              <div  class="overflow-text">
                  <ng-container *ngTemplateOutlet="displayCell; context: { $implicit: rowData, col: col }"></ng-container>
              </div>
          </ng-template>
        </ng-template>
      </laas-data-table>
      <laas-data-table
        #customerLabelDetailTable
        [tableKey]="detailPreferenceKey"
        [defaultColumns]="customerLabelDetailColumns"
        [loading]="isLoadingDetail"
        [value]="customerLabelDetailRowDatas"
        [lazy]="true"
        [paginator]="false"
        [editPermission]="editPermissionCode"
        [inputValid]="dataInputValid"
        [isShowCreateRowFunction]="false"
        (savedData)="saveCustomerLabelDetail($event)"
        [dataKey]="'seqNo'"
        >
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container *ngTemplateOutlet="defaultTemplate; context: { $implicit: rowData, col: col }">
             </ng-container>
          </td>
        </ng-template>
        <!--Input (detail) -->
        <ng-template pTemplate="bodyInputTemplate" let-rowData let-col="col">
          <ng-container *ngIf="isDetailColumnEditable(col.field,rowData['isCustLabelEditable']); else elseTemplate">
            <input pInputText type="text" class="p-inputtext p-component p-element p-filled" [(ngModel)]="rowData[col.field]" />
          </ng-container>

          <ng-template #elseTemplate>
            <div class="overflow-text">
              <ng-container *ngTemplateOutlet="displayCell; context: { $implicit: rowData, col: col }"></ng-container>
            </div>
          </ng-template>
        </ng-template>
        <!--Output-->
        <ng-template #defaultTemplate pTemplate="bodyOutputTemplate" let-rowData let-col="col">
              <div  class="overflow-text">
                  {{ rowData[col.field] | replaceNullWith : "-" }}
              </div>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
<help-dock
  [permissionCode]="viewPermission"
  [lang]="currentLang">
</help-dock>
